/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * feedTokens
 * ----------
 * The athlete feed's palette. Like the organizer surface it renders on a fixed
 * palette rather than following the theme switcher — but its orange is the
 * portal's own, read from the `agni` theme so the two can never drift apart:
 *   accent       agni.primary       #FF6A1A — the home page's --ah-orange
 *   accentHover  agni.primaryLight  #FF8440
 *   accentText   agni.text          #C2410C — #FF6A1A fails AA as small text
 *   tint         agni.footer        #FFF1E8
 * Ink and neutrals come from UpVibe's default "Chandra" theme (white + orange),
 * the app these activities were recorded in.
 *
 * Spread FEED_TOKENS onto the shell's style prop; feed components read var(--fd-*).
 */

import { agniTheme } from './themes';

const INK_RGB = '36, 23, 8';        // #241708 — UpVibe Chandra text
const ACCENT_RGB = '255, 106, 26';  // #FF6A1A

export const FEED_TOKENS = {
  '--fd-bg': '#FFFFFF',
  '--fd-surface': '#FFFFFF',
  '--fd-surface-2': '#FAF7F4',
  '--fd-surface-3': '#F4EFEA',
  '--fd-ink': '#241708',
  '--fd-dim': `rgba(${INK_RGB}, 0.60)`,
  '--fd-mute': `rgba(${INK_RGB}, 0.40)`,
  '--fd-line': `rgba(${INK_RGB}, 0.10)`,
  '--fd-line-soft': `rgba(${INK_RGB}, 0.06)`,
  '--fd-accent': agniTheme.primary,
  '--fd-accent-hover': agniTheme.primaryLight,
  '--fd-accent-text': agniTheme.text,
  '--fd-tint': agniTheme.footer,
  '--fd-accent-wash': `rgba(${ACCENT_RGB}, 0.10)`,
  '--fd-accent-shadow': `rgba(${ACCENT_RGB}, 0.30)`,
  '--fd-peach': '#FFE3D1',
  '--fd-bar': '#FFB68F',
  '--fd-bar-hover': agniTheme.secondary,
  '--fd-good': '#1B7F48',
  '--fd-good-soft': 'rgba(27, 127, 72, 0.10)',
  '--fd-bad': '#C8432E',
  '--fd-bad-soft': 'rgba(200, 67, 46, 0.10)',
  '--fd-inv': '#241708',
  '--fd-inv-dim': 'rgba(255, 255, 255, 0.66)',
  '--fd-map-land': '#F5F0EB',
  '--fd-shadow-sm': `0 1px 2px rgba(${INK_RGB}, 0.05)`,
  '--fd-shadow': `0 1px 2px rgba(${INK_RGB}, 0.04), 0 12px 32px -16px rgba(${INK_RGB}, 0.18)`,
  '--fd-shadow-lg': `0 24px 60px -20px rgba(${INK_RGB}, 0.28)`,
};

export default FEED_TOKENS;
